module.exports = __webpack_public_path__ + "img/pic-04.3995dd40.jpg";